import React from 'react';
import { Edit2Icon, Trash2Icon } from 'lucide-react';
const mockUsers = [{
  id: 1,
  name: 'Ana María González',
  email: 'ana.gonzalez@example.com',
  role: 'Administrador',
  status: true,
  createdAt: '2024-01-15'
}, {
  id: 2,
  name: 'Carlos Rodríguez',
  email: 'carlos.rodriguez@example.com',
  role: 'Usuario',
  status: true,
  createdAt: '2024-01-14'
}];
export const UserTable = () => {
  return <div className="bg-white rounded-lg shadow overflow-hidden" data-id="element-1190">
      <div className="overflow-x-auto" data-id="element-1191">
        <table className="min-w-full divide-y divide-gray-200" data-id="element-1192">
          <thead className="bg-gray-50" data-id="element-1193">
            <tr data-id="element-1194">
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1195">
                Nombre
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1196">
                Email
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1197">
                Rol
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1198">
                Estado
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1199">
                Fecha Creación
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1200">
                Acciones
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200" data-id="element-1201">
            {mockUsers.map((user, index) => <tr key={user.id} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'} data-id="element-1202">
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-1203">
                  <div className="text-sm font-medium text-gray-900" data-id="element-1204">
                    {user.name}
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-1205">
                  <div className="text-sm text-gray-500" data-id="element-1206">{user.email}</div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-1207">
                  <div className="text-sm text-gray-900" data-id="element-1208">{user.role}</div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-1209">
                  <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${user.status ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`} data-id="element-1210">
                    {user.status ? 'Activo' : 'Inactivo'}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-1211">
                  <div className="text-sm text-gray-500" data-id="element-1212">{user.createdAt}</div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium" data-id="element-1213">
                  <div className="flex space-x-3" data-id="element-1214">
                    <button className="text-blue-600 hover:text-blue-900" data-id="element-1215">
                      <Edit2Icon className="h-5 w-5" data-id="element-1216" />
                    </button>
                    <button className="text-red-600 hover:text-red-900" data-id="element-1217">
                      <Trash2Icon className="h-5 w-5" data-id="element-1218" />
                    </button>
                  </div>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
};